import { doPoint } from '@assets/utils';

const { $ } = window;
$('.ask-doctor-btn').click(() => {
  const position = $('.ask-doctor-btn').data('position');
  const domain = $('.ask-doctor-btn').data('domain');
  const doctorId = $('.ask-doctor-btn').data('doctor-id');
  const graphPrice = $('.ask-doctor-btn').data('graph-price');

  let pointPosition = '';
  switch (position) {
    case 'qa-audio-detail':
      pointPosition = '语音话题详情页';
      break;
    case 'qa-multiple-detail':
      pointPosition = '医患问答详情页';
      break;
    case 'topic-detail':
      pointPosition = '文字话题详情页';
      break;
    default:
      pointPosition = '';
  }

  doPoint.appClick(domain, {
    click_position: '向TA提问',
    page_readable_name: pointPosition,
  }, () => {
    if (Number(graphPrice) === -1) {
      window.location.href = `${domain}/pc/doctor/${doctorId}/`;
    } else {
      window.location.href = `${domain}/pc/wx_qr_page/?from_type=seo-pc&order_type=graph&doctor_id=${doctorId}`;
    }
  });
});

$('.follow-btn').mouseover(() => {
  $('.qr-code-wrapper').addClass('show');
});

$('.follow-btn').mouseout(() => {
  $('.qr-code-wrapper').removeClass('show');
});
